import { Component, OnInit, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, take } from "rxjs";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { selectSubmissionSuccessData } from "@store/selectors/mips-packet/mips-packet.selector";
import { MipsPacketActions } from "@store/actions/mips-packet/mips-packet.actions";

@Component({
  selector: "app-mips-submission-score",
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, MatButtonModule, MatIconModule],
  templateUrl: "./mips-submission-score.component.html",
  styleUrls: ["./mips-submission-score.component.css"],
})
export class MipsSubmissionScoreComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  submissionData$: Observable<any>;

  constructor() {
    this.submissionData$ = this.store.select(selectSubmissionSuccessData);
  }

  ngOnInit(): void {
    this.submissionData$.pipe(take(1)).subscribe((data) => {
      if (data?.packetId && data.finalScore === null && !data.scoreLoading) {
        this.store.dispatch(MipsPacketActions.getSubmissionScore({ submissionId: data.packetId }));
      }
    });
  }

  getCategoryDisplayName(category: string): string {
    const names: Record<string, string> = {
      quality: 'Quality',
      pi: 'Promoting Interoperability',
      ia: 'Improvement Activities',
      cost: 'Cost',
    };
    return names[category] ?? category;
  }

  hasCostCategory(categoryScores: any[]): boolean {
    return categoryScores?.some((c) => c.category === 'cost') ?? false;
  }

  onReturnHome(): void {
    this.router.navigate(["/"]);
  }
}
